import { StoreLessonKBS } from "@/store/constants";
import WaitTimer from '@/store/waitTimer';

import { appData } from "@/helpers/global";
import { LessonKBSService } from "@/services/api/lesson-kbs";

const module = {
    namespaced: true,
    timer: {
        list: new WaitTimer(StoreLessonKBS.state.list, 24 * 60 * 60),
    },
    state: () => ({
        list: [],
    }),
    mutations: {
        setList(state, data) {
            if (state.list != data) {
                state.list = data;
            }
        },
    },
    actions: {
        setList(ctx, data) {
            ctx.commit("setList", data);
            module.timer.list.resetLastFetchTime();
        },
        loadList({ state, dispatch }, p) {
            if (p.detect && state.list.length > 0) {
                if (module.timer.list.getLastFetchTime() < p.detect) {
                    p.reset = true;
                }
                else {
                    return;
                }
            }
            if (state.list.length == 0 || p.reset || module.timer.list.isTimeExpired(module.timer.list.timeOut)) {
                LessonKBSService.List(function (data) {
                    dispatch("setList", data);
                    p.callback();
                }, p.wait);
            }
            else {
                p.wait();
                p.callback();
            }
        }
    },
    getters: {
        getList(state) {
            return state.list;
        }
    }
};
export default module;